import {Injectable} from '@angular/core';
import {ApiService} from "@biletix/core/services/api.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ApiResponse} from "@biletix/core/models/api-response";
import {map} from "rxjs/operators";
import {Town} from "@biletix/core/models/town.model";

@Injectable({
  providedIn: 'root'
})
export class TownService {

  private basePath: string = "/api/v1/bxcached/town";

  constructor(private apiService: ApiService,
              private http: HttpClient) {
  }

  public getTownListByCityId(cityId: number): Observable<Town[]> {
    return this.http.get<ApiResponse<Town[]>>(//
      `${this.apiService.getCrmApiHost()}${this.basePath}/list`,
      {params: {cityId: cityId}})//
      .pipe(map(response => response.data));
  }
}
